// Centralised API base URLs.
// Values come from the .env.production / .env.staging / .env.development files
// (loaded automatically by react-scripts, or via `env-cmd` for the build:* scripts).
export const API_URL = process.env.REACT_APP_API_URL || 'https://api.al-jariyah.com/api';
export const CP_API_URL = process.env.REACT_APP_CP_API_URL || 'https://cp-api.al-jariyah.com/admin';
